import { OMPMakerEventConstantS } from '../Constant/module/OMPMakerEventConstantS.js';

export const findEventByCoupon = (coupon) => {
  return OMPMakerEventConstantS.EVENTS.find((info) => info.coupon === coupon);
};
